import { useEffect, useState } from "react";
import { CgBell } from "react-icons/cg";
import { useDispatch, useSelector } from "react-redux";
import { ShimmerContentBlock } from "react-shimmer-effects";
import { Link, useLocation, useNavigate } from "react-router";

import SearchBar from "./SearchBar";
import SavedPreference from "./save-preference";
import HubzuHeaderMenu from "./dashboard/HubzuHeaderMenu/HubzuHeaderMenu";

import Alerts from "@/components/user/Alerts";
import { trackPageMount } from "@/utils/analytics";
import { setLoginTab } from "@/redux/login/loginSlice";

const Header = ({ hasBanner = false }) => {
  const navigate = useNavigate();
  const [navbar, setNavbar] = useState(false);
  const [showSearchOnHome, setShowSearchOnHome] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const loading = useSelector((state) => state?.user?.isAlertsLoading);
  const isUserLoggedIn = useSelector((state) => state?.user?.isUserLoggedIn);

  const isHomePage = location.pathname === "/";

  const isSellResidentialHeader =
    location.pathname === "/sell-a-home-in-an-online-auction/" ||
    location.pathname === "/sellahomeinanonlineauction" ||
    location.pathname === "/sell-a-home-in-an-online-auction/seller/";

  const changeBackground = () => {
    if (window.scrollY >= 95) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };
  const handleShowNavbar = () => {
    if (window.scrollY >= 400) {
      setShowSearchOnHome(true);
    } else {
      setShowSearchOnHome(false);
    }
  };
  // Function to handle sidebar open/close
  useEffect(() => {
    const offcanvasElement = document.getElementById("ss");

    const handleOpen = () => setIsSidebarOpen(true);
    const handleClose = () => setIsSidebarOpen(false);

    offcanvasElement?.addEventListener("shown.bs.offcanvas", handleOpen);
    offcanvasElement?.addEventListener("hidden.bs.offcanvas", handleClose);

    // Cleanup event listeners when the component is unmounted
    return () => {
      offcanvasElement?.removeEventListener("shown.bs.offcanvas", handleOpen);
      offcanvasElement?.removeEventListener("hidden.bs.offcanvas", handleClose);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", changeBackground);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleShowNavbar);
    return () => {
      window.removeEventListener("scroll", handleShowNavbar);
    };
  }, []);

  const [showAlerts, setShowAlerts] = useState(false);

  useEffect(() => {
    const alertsDrawer = document.getElementById("alertsSidebarListing");

    const handleOpen = () => {
      trackPageMount({
        pageName: "header_alerts_click",
        eventCategory: "Global Alerts",
        eventSource: "Header Alert click",
        eventLabel: `Status - Opened`,
      });
      setShowAlerts(true);
    };

    const handleClose = () => {
      if (showAlerts) {
        trackPageMount({
          pageName: "header_alerts_click",
          eventCategory: "Global Alerts",
          eventSource: "Header Alert click",
          eventLabel: `Status - Closed`,
        });
        setShowAlerts(false);
      }
    };

    alertsDrawer?.addEventListener("show.bs.offcanvas", handleOpen);
    alertsDrawer?.addEventListener("hide.bs.offcanvas", handleClose);

    return () => {
      alertsDrawer?.removeEventListener("show.bs.offcanvas", handleOpen);
      alertsDrawer?.removeEventListener("hide.bs.offcanvas", handleClose);
    };
  }, [showAlerts]);

  // Open alerts drawer if URL contains ?openAlerts=true (from email notification links)
  // Waits for session to be validated (isUserLoggedIn) then clicks the alerts link
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("openAlerts") === "true" && isUserLoggedIn) {
      // Give time for the header alerts link to render after login
      setTimeout(() => {
        const alertsLink = document.getElementById("header-alerts-link");
        if (alertsLink) {
          alertsLink.click();
        }
        // Clean up the URL param without reloading
        const url = new URL(window.location);
        url.searchParams.delete("openAlerts");
        window.history.replaceState({}, "", url);
      }, 500);
    }
  }, [isUserLoggedIn]);

  return (
    <>

      <header
      className={`header-nav ${
        isHomePage
          ? // ? 'menu_style_home_one navbar-scrolltofixed stricky main-menu'
            "header-nav menu_style_home_one style2 navbar-scrolltofixed stricky main-menu stricky-fixed"
          : "header-nav menu_style_home_one style2 navbar-scrolltofixed stricky main-menu"
      } ${navbar ? "stricky-fixed" : ""}`}
      style={{ top: hasBanner ? '40px' : '0px' }}
    >

      <div className="container-fluid p0">
        <div className="d-flex align-items-center flex-wrap">
          {/* <!-- Menu Toggle btn--> */}
          <Link
            to="/"
            id="header-logo-link"
            className="navbar_brand float-start dn-smd mr0 mt0 ml10"
            onClick={isHomePage ? () => navigate(0) : undefined}
          >
            <img
              className={isHomePage ? "logo1 contain" : "logo1 img-fluid"}
              src={
                isHomePage
                  ? "/assets/images/hubzu-logo-white.png"
                  : "/assets/images/hubzu-logo.png"
              }
              alt={isHomePage ? "hubzu-logo-white.png" : "hubzu-logo.png"}
            />

            <img
              className={`logo2 ${isHomePage ? "contain" : "img-fluid"}`}
              src="/assets/images/hubzu-logo.png"
              alt="hubzu-logo.png"
            />
          </Link>
          {/* site logo brand */}

          {/*search bar on header dont show on home page*/}
          {((!isHomePage && !isSellResidentialHeader) ||
            (isHomePage && showSearchOnHome)) && (
            <ul className="float-left">
              <li className="list-inline-item search__menu-top">
                <SearchBar />
              </li>
            </ul>
          )}

          <nav className="ms-auto">
            <HubzuHeaderMenu />
          </nav>
          {/* End .navbar */}
        </div>
      </div>
      {/* Alets flyout start */}
      <div
        className="offcanvas offcanvas-end offcanvas-listing-sidebar"
        id="alertsSidebarListing"
        style={{ width: "50%" }}
        data-bs-scroll="true"
        data-bs-backdrop="false"
      >
        <div className="offcanvas-header">
          <CgBell size={38} color="#2A69A3" />
          <h1 className="offcanvas-title title-txt">Alerts</h1>
          <button
            type="button"
            id="alerts-close-btn"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={() => dispatch(setLoginTab("loginTab"))}
          ></button>
        </div>
        {/* End .offcanvas-heade */}

        <div className="offcanvas-body">
          <div className="sidebar_listing_list pt0">
                {loading ?<div className="text-center p-4 mt10">
                            <div className="mt30 pt30" role="">
                                                    {[1, 2].map((item) => (
                                                      <div key={item} className="w-100 mb-3">
                                                        <ShimmerContentBlock
                                                          cta
                                                          card
                                                            //  title
                                                          text
                                                          thumbnailWidth={130}
                                                          thumbnailHeight={100}
                                                        />
                                                      </div>
                                                        ))}
                            </div>
                          </div> : <Alerts />}

            {/* <Alerts /> */}
          </div>
        </div>
      </div>
       <div
          className="offcanvas offcanvas-end offcanvas-listing-sidebar"
          tabIndex="-1"
          id="ss"
        >
          {isSidebarOpen && <SavedPreference />}
        </div>
      {/* Alets flyout ends */}
      </header>
    </>
  );
};

export default Header;
